/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExpenseDtoSearchResponse } from '../../models/expense-dto-search-response';

export interface SearchExpenseQuery$Plain$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
  Date?: string;
}

export function searchExpenseQuery$Plain(http: HttpClient, rootUrl: string, params?: SearchExpenseQuery$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExpenseDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchExpenseQuery$Plain.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
    rb.query('Date', params.Date, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExpenseDtoSearchResponse>;
    })
  );
}

searchExpenseQuery$Plain.PATH = '/api/expense';
